<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import PlaceholderContent from '../UI/Loading/PlaceholderContent.vue'

export default {
  components: {
    PlaceholderContent,
    ModalConfirmation,
    ButtonAll,
    FieldCreator,
    BlockContent,
    FormCreator,
    ModalDialog,
  },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    context: { type: String, required: true },
    contextId: { type: Number, required: true },
    master: { type: String, default: null, required: false },
    masterId: { type: Number, default: null, required: false },
    messageId: { type: Number, default: null, required: false },
    media: { type: String, default: 'EMAIL' },
    contextValidate: { type: Boolean, default: false },
    canSaveMessage: { type: Boolean, default: true },
    hide: { type: Boolean, default: false },
    additionalContexts: { type: Array, default: [], required: false },
    internalName: { type: String, required: false },
    selectFirstTemplate: { type: Boolean, default: false, required: false },
    selectedRecipientId: { type: Number, default: null, required: false },
    buttonLabel: { type: String, default: null, required: false },
    buttonType: { type: String, default: null, required: false },
    buttonSize: { type: String, default: null, required: false },
    defaultRecipientIds: { type: Array, default: [], required: false },
  },

  data: () => ({
    method: 'post',
    message: {},
    def: {},
    params: {},
    loadField: false,
    loadForm: false,
    sending: false,
    prepareSending: false,
    opening: false,
    recipients: [],
    newRecipients: [],
    recipient: null,
    checkRecipients: true,
    filesize: 0,
    formData: null,
    toSave: false,
    loadingTemplate: false,
  }),

  watch: {
    'message.attachments': {
      handler(attachments) {
        this.filesize = 0
        for (const attachment of attachments) {
          if (this.message.attachmentSize[attachment]) {
            this.filesize += parseInt(this.message.attachmentSize[attachment])
          }
        }
      },
      deep: true,
    },
  },

  computed: {
    checkedRecipients: {
      get() {
        return (this.message?.recipients || [])
          .filter((recipient) => recipient && recipient.toSend === true)
          .map((recipient) => recipient.contextId ?? recipient.id)
      },
      set(newRecipient) {
        if (!this.message?.recipients) return

        this.message.recipients = this.message.recipients.map((recipient) => {
          if (!recipient) {
            return recipient
          }
          if (recipient.selected) {
            return recipient
          }
          return { ...recipient, toSend: newRecipient.includes(recipient.contextId ?? recipient.id) }
        })
      },
    },
    contentBlockClasses() {
      return ['col', this.media === 'EXTERNAL' ? 'row' : 'bloc']
    },
    componentId() {
      return [this.messageId ?? 'new', this.masterId ?? 'none', this.contextId].join('-')
    },
    hasToSendRecipient() {
      return this.toSendRecipients().length > 0
    },
    hasInvalidEmail() {
      if (this.media !== 'EMAIL') {
        return false
      }

      let hasInvalidEmail = false
      if (this.newRecipients && this.newRecipients.length > 0) {
        this.newRecipients.forEach((recipient) => {
          if (!this.emailIsValid(recipient.address) && recipient.address !== '') {
            hasInvalidEmail = true
            recipient.invalidEmail = true
          } else {
            recipient.invalidEmail = false
          }
        })
      } else {
        return false
      }
      return hasInvalidEmail
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    toSendRecipients() {
      let toSendRecipients = this.message.recipients.filter((recipient) => {
        return recipient.toSend === true
      })

      if (this.media === 'EMAIL') {
        this.newRecipients.forEach((recipient) => {
          const model = {
            id: null,
            name: recipient.name,
            address: recipient.address,
            status: 'CREATED',
            statusInfo: null,
            context: null,
            contextId: null,
            toSend: true,
            tobcc: recipient.cc ? 'cc' : 'to',
          }
          if (this.emailIsValid(recipient.address)) {
            toSendRecipients.push(JSON.parse(JSON.stringify(model)))
          }
        })
      }

      return toSendRecipients
    },
    emailIsValid(email) {
      return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
        email,
      )
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.message = obj

      if (this.def?.recipients?.options?.choices) {
        if (Object.keys(this.def.recipients.options.choices).length > 6) {
          this.checkRecipients = false
        }
      }

      this.recipients = this.message.recipients.map((recipient) => {
        if (recipient.toSend) {
          return recipient
        }
      })
      if (this.recipients.length > 0) {
        this.recipients = this.recipients.filter((recipient) => {
          return recipient != null
        })
      } else {
        //pour supprimer les destinataires créés
        this.recipients = []
        this.newRecipients = []
      }
      this.opening = false

      if (
        this.selectFirstTemplate &&
        this.def?.template?.options?.choices &&
        !this.$refs.myformmessage.object['template']
      ) {
        const firstTemplate = this.def?.template?.options?.choices[0].id
        this.$refs.myformmessage.object['template'] = firstTemplate
        this.updateMessage(firstTemplate)
      }

      if (this.selectedRecipientId) {
        this.setRecipients(this.selectedRecipientId)
      }
    },
    isSending(bool) {
      this.sending = bool
    },
    showForm() {
      this.params = {
        context: this.context.replace(/\//g, '\\'),
        contextId: this.contextId,
        media: this.media,
      }
      if (this.master && this.masterId) {
        this.params['master'] = this.master.replace(/\//g, '\\')
        this.params['masterId'] = this.masterId
      }

      for (let index = 0; index < this.additionalContexts.length; index++) {
        this.params[`additionalContexts[${index}][context]`] = this.additionalContexts[index]['context'].replace(
          /\//g,
          '\\',
        )
        this.params[`additionalContexts[${index}][contextId]`] = this.additionalContexts[index]['contextId']
      }

      if (this.messageId) {
        this.params['messageId'] = this.messageId
      }
      if (this.internalName) {
        this.params['internalName'] = this.internalName
      }

      for (const [index, id] of this.defaultRecipientIds.entries()) {
        this.params[`defaultRecipientIds[${index}]`] = id
      }

      this.loadForm = true
      this.opening = true
    },
    async updateMessage(val, choices) {
      this.loadingTemplate = true
      this.$refs.myformmessage.params['template'] = val
      try {
        await this.$refs.myformmessage.get()
      } finally {
        this.loadingTemplate = false
      }
    },
    openModal() {
      this.$refs['message' + this.componentId].open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.prepareSending = false
      this.sending = false
      this.opening = false
      this.recipients = []
      this.newRecipients = []
      this.$refs['message' + this.componentId].close(false)
      delete this.params.id
    },
    setDatas(json) {
      this.$emit('message-sent', { json: json, method: this.method })
      this.closeModal()
    },
    addRecipient() {
      this.newRecipients.push({
        name: '',
        address: '',
        cc: false,
        invalidEmail: false,
      })
    },
    removeAdd(index) {
      this.newRecipients.splice(index, 1)
    },
    removeRecipient(index) {
      this.recipients[index].toSend = false
      this.recipients.splice(index, 1)
    },
    setRecipients(recipientNameOrId) {
      if (recipientNameOrId) {
        let item = null
        this.message.recipients = this.message.recipients.map((recipient) => {
          if (recipient.name === recipientNameOrId || recipient.contextId === recipientNameOrId) {
            recipient.toSend = true
            recipient.selected = true
            item = recipient
          }
          return recipient
        })

        let index = this.recipients.findIndex((recipient) => recipient.contextId === item.contextId)
        index === -1 ? this.recipients.push(item) : null
        this.recipient = null
      }
    },
    getSize(id) {
      let size = 0
      if (this.message.attachmentSize[id]) {
        size = parseInt(this.message.attachmentSize[id])
        if (size > 1000) {
          return Math.round(size / 1000) + ' Ko'
        } else if (size > 1000000) {
          return Math.round(size / 1000000) + ' Mo'
        } else {
          //pour toutes valeurs < ou = à 1 Ko
          return '1 Ko'
        }
      } else {
        return ''
      }
    },
    isHtmlStringVisiblyEmpty(htmlString) {
      const div = document.createElement('div')
      div.innerHTML = htmlString
      return div.textContent.trim() === ''
    },
    sendMessage(save) {
      if (this.hasToSendRecipient === false && this.media !== 'EXTERNAL') {
        alert(this.$t('message.errors.missingToSendRecipients'))
        return
      }

      if (this.$refs.inputCheckbox) {
        const filtered = this.message.attachments.filter((el) => {
          return typeof el !== 'object'
        })
        for (const [index, check] of Object.entries(this.$refs.inputCheckbox)) {
          if (check.checked) {
            filtered.push(check.value)
          }
        }
        this.message.attachments = filtered
      }
      this.toSave = save
      if (this.mandatoryAttachment && this.message.attachments.length === 0) {
        this.$refs['message' + this.componentId].close(false)
        this.$refs['modalConfirmationMessage' + this.componentId].showModal()
      } else {
        this.confirmSendMessage()
      }
    },
    cancelSendMessageWithoutAttachments() {
      this.openModal()
    },
    confirmSendMessage() {
      this.$refs['modalConfirmationMessage' + this.componentId].closeModal()
      let object = {
        context: this.context.replace(/\//g, '\\'),
        contextId: this.contextId,
        additionalContexts: this.additionalContexts,
        media: this.media,
        id: this.messageId,
        showPrepareMessage: true,
        attachments: this.message.attachments,
        attachmentSize: this.message.attachmentSize,
      }
      if (this.master && this.masterId) {
        object['master'] = this.master.replace(/\//g, '\\')
        object['masterId'] = this.masterId
      }

      if (this.media !== 'EXTERNAL') {
        object['recipients'] = this.toSendRecipients()
      }

      for (const [key, value] of Object.entries(object)) {
        this.$refs.myformmessage.datas[key] = value
      }

      if (
        (this.isHtmlStringVisiblyEmpty(this.$refs.myformmessage.datas['body']) ||
          this.isHtmlStringVisiblyEmpty(this.$refs.myformmessage.datas['subject'])) &&
        this.media === 'EMAIL'
      ) {
        alert(this.$t('message.errors.missingToSendBody'))
        return
      }

      if (this.toSave) {
        this.prepareSending = true
      } else {
        this.sending = true
      }

      if (this.messageId) {
        this.patchJSON(
          'messages/' + this.messageId,
          JSON.stringify({ message: this.$refs.myformmessage.datas, save: this.toSave }),
        ).then((message) => {
          if (message.errors) {
            alert(message.errors)
          }
          this.$emit('message-sent', message)
          this.closeModal()
          //this.toSave <=> isBrouillon
          if (this.contextValidate && !this.toSave) {
            this.$emit('page-validation')
          }
        })
      } else {
        this.postJSON('messages', JSON.stringify({ message: this.$refs.myformmessage.datas, save: this.toSave })).then(
          (message) => {
            if (message.errors) {
              alert(message.errors)
            }
            this.$emit('message-sent', message)
            this.closeModal()
          },
        )
      }
    },
  },
}
</script>
<template>
  <ButtonAll
    v-if="!hide"
    :type="buttonType ?? (messageId ? 'warning' : 'validation')"
    :label="buttonLabel ?? $t('message.' + (messageId ? 'draft' : 'title'))"
    :size="buttonSize"
    :loading="opening"
    :icon="messageId ? 'mail' : null"
    margin="no"
    @click="showForm"
    e2e-button="showMessage"
  />

  <ModalDialog
    :ref="'message' + componentId"
    :id="'message' + (messageId ? messageId : componentId)"
    class-modal-dialog="modal-xl"
    @icon-close="closeModal"
    e2e-modal="message"
  >
    <FormCreator
      @update-data="updateData"
      v-if="loadForm"
      ref="myformmessage"
      src-error="myformmessage"
      endpoint="messages"
      :method="method"
      :id="messageId"
      :params="params"
      :in-modal="true"
      class-to-add="d-none"
      @modal-build="openModal"
      @form-build="setBuild"
      @element-build="setElement"
      @form-return="setDatas"
      @is-sending="isSending"
    ></FormCreator>
    <template #body>
      <div class="row">
        <div v-if="media !== 'EXTERNAL'" class="col card">
          <BlockContent title-t="message.title">
            <div class="col">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="template"
                form-ref="myformmessage"
                domain="message"
                :not-required="true"
                @get-select-change="updateMessage"
              ></FieldCreator>
            </div>
            <template v-if="!loadingTemplate">
              <div class="col">
                <FieldCreator
                  :form-data="formData"
                  v-if="loadField"
                  name="subject"
                  form-ref="myformmessage"
                  domain="message"
                ></FieldCreator>
              </div>
              <div class="col">
                <FieldCreator
                  :form-data="formData"
                  v-if="loadField"
                  form-ref="myformmessage"
                  name="body"
                  domain="message"
                  :editor="true"
                ></FieldCreator>
              </div>
            </template>
            <PlaceholderContent v-else :rows="6" />
          </BlockContent>
        </div>
        <div :class="contentBlockClasses">
          <div v-if="media !== 'EXTERNAL'">
            <h4 class="font-weight-bold" v-html="$t('message.recipient.placeholder')"></h4>
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="recipients"
              form-ref="myformmessage"
              domain="message"
              type-value="string"
              :not-required="true"
              @get-select-change="setRecipients"
            ></FieldCreator>
            <table v-if="loadField" class="table table-bordered">
              <thead>
                <tr class="text-center">
                  <th>{{ $t('userEntity.fields.user.lastname.label') }}</th>
                  <th>{{ $t('userEntity.fields.user.email.label') }}</th>
                  <th>{{ $t('userEntity.fields.user.action.tobcc') }}</th>
                  <th v-if="checkRecipients">{{ $t('userEntity.fields.user.action.add') }}</th>
                  <th>{{ $t('userEntity.fields.user.action.delete') }}</th>
                </tr>
              </thead>
              <tbody ref="choicesRecipient">
                <tr
                  v-for="(recipient, index) in def.recipients.options.choices"
                  v-if="checkRecipients && def && def.recipients && def.recipients.options"
                >
                  <td>{{ recipient.name }}</td>
                  <td>{{ recipient.address }}</td>
                  <td>
                    <input type="checkbox" disabled v-model="recipient.cc" />
                  </td>
                  <td class="text-center">
                    <input
                      type="checkbox"
                      :id="recipient.id"
                      v-model="checkedRecipients"
                      :value="recipient.contextId"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr v-for="(recipient, index) in recipients" class="recipient-list" v-if="!checkRecipients">
                  <td>{{ recipient.name }}</td>
                  <td>{{ recipient.address }}</td>
                  <td>
                    <input type="checkbox" disabled v-model="recipient.cc" />
                  </td>
                  <td class="text-center"><i class="fas fa-times" @click="removeRecipient(index)"></i></td>
                </tr>
                <tr v-for="(recipient, index) in newRecipients" class="recipient-list">
                  <td>
                    <input v-model="recipient.name" class="form-control" style="width: 150px; padding-left: 10px" />
                  </td>
                  <td>
                    <input
                      v-model="recipient.address"
                      class="form-control"
                      :style="recipient.invalidEmail ? 'border-color:red;' : ''"
                      style="width: 150px; padding-left: 10px"
                      type="text"
                    />
                  </td>
                  <td>
                    <input type="checkbox" v-model="recipient.cc" />
                  </td>
                  <td class="text-center" v-if="checkRecipients"><i class="fas fa-check text-success"></i></td>
                  <td class="text-center"><i class="fas fa-times new-recipient" @click="removeAdd(index)"></i></td>
                </tr>
              </tbody>
            </table>
            <div v-if="hasInvalidEmail">
              <span ref="mailMissing" style="color: red">{{ $t('message.missing.mail') }}</span>
            </div>
            <ButtonAll
              margin="no"
              type="validation"
              @click="addRecipient"
              label="message.recipient.add"
              name="addRecipient"
            />
          </div>
          <div v-if="def && def.attachments && def.attachments.length > 0" class="mt-3">
            <h4 class="font-weight-bold" v-html="$t('message.attachments.placeholder')"></h4>
            <div v-for="(attachment, index) in def.attachments" class="form-group row">
              <label :for="'message-form-attachment-' + index" class="col-10 col-form-label text-right">{{
                attachment.label + ' (taille: ' + getSize(attachment.value) + ')'
              }}</label>
              <!--<FieldCreator v-if="loadField" name="attachment" :collection-specific="true" :collection-index="index" collection-name="attachments" form-ref="myformmessage" :not-required="true"></FieldCreator>-->
              <div class="col-2 col-form-group">
                <div class="input-group">
                  <input
                    v-if="attachment.options.checked != 'checked'"
                    :id="'message-form-attachment-' + index"
                    type="checkbox"
                    :value="attachment.value"
                    v-model="message['attachments']"
                    style="margin: 12px 0px"
                  />
                  <input
                    type="checkbox"
                    ref="inputCheckbox"
                    :id="'message-form-attachment-' + index"
                    :value="attachment.value"
                    :checked="attachment.options.checked"
                    style="margin: 12px 0px"
                    v-else
                  />
                  <div class="invalid-feedback"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="mt-3">
        <span v-if="filesize > 13000000" class="text-warning">{{ $t('message.limitMessage') }}</span>
        <ButtonAll
          v-if="canSaveMessage"
          margin="no"
          type="warning"
          label="message.prepare"
          @click="sendMessage(true)"
          :loading="prepareSending"
          :disabled="loadingTemplate"
          e2e-button="saveMessage"
        />
        <ButtonAll
          margin="no"
          :type="filesize > 13000000 || hasInvalidEmail ? 'disabled' : 'validation'"
          label="message.send"
          class="ml-2"
          :loading="sending"
          :disabled="loadingTemplate"
          e2e-button="sendMessage"
          @click="sendMessage(false)"
        />
        <ButtonAll
          margin="no"
          data-dismiss="modal"
          type="information"
          label="button.close"
          class="ml-2"
          e2e-button="close"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDialog>
  <ModalConfirmation
    :ref="'modalConfirmationMessage' + componentId"
    :id="'Message' + componentId"
    title="message.information.actionConfirmed.emptyAttachments"
    button-confirm-title="main.bool.true"
    button-cancel-title="main.bool.false"
    @confirm="confirmSendMessage"
    @cancel="cancelSendMessageWithoutAttachments"
  />
</template>
app.component("messageForm", );
